<template>
    <div ref="adminTabItems" class="tab-items mb-3">
        <EMDataTable ref="consentsTable" :column-def="columnDef" :data-url="'/admin/consents'" sort="updated_at" sort_dir="desc" @data-loaded="helper.loaderOff(adminTabItems)" @loading-data="helper.loaderOn(adminTabItems)">
            <template v-slot:consent="{ rowData, column }">
                <td :style="column.width ? 'width: '+column.width+'%' : ''" class="cursor-pointer consent-col" @click="toggleExpand(rowData.consent_id)">
                    <div v-if="!isExpanded(rowData.consent_id)">
                        <div class="consent-content">
                            <p class="m-0 text-muted fs-sm pre" v-max-lines="1" v-html="rowData.consent"></p>
                        </div>
                        <small class="text-primary">Click to expand</small>
                    </div>
                    <div v-else>
                        <div class="consent-content">
                            <div class="m-0 text-muted fs-sm pre wrap" v-html="rowData.consent"></div>
                        </div>
                        <small class="text-primary">Click to collapse</small>
                    </div>
                </td>
            </template>
            <template v-slot:consent_type="{ rowData, column }">
                <td :style="column.width ? 'width: '+column.width+'%' : ''">
                    <p class="m-0 text-dark text-capitalize text-decoration-underline">{{ rowData.consent_type }}</p>
                </td>
            </template>
            <template v-slot:survey_id="{ rowData, column }">
                <td :style="column.width ? 'width: '+column.width+'%' : ''">
                    <router-link v-if="rowData.survey_id !== null" class="text-primary fs-sm text-decoration-none" :to="{name: 'single_survey', params: {id: rowData.uuid }}">Survey: {{ rowData.survey_id }} - {{ rowData.name }}</router-link>
                </td>
            </template>
            
        </EMDataTable>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import EMDataTable from '../../components/Table/EMDataTable.vue';
import { useAppHelpers } from '@/composables/useAppHelpers';
import { useAuthStore } from "@/stores/auth-store";

const pages = ['terms', 'privacy'];

const auth = useAuthStore();
const helper = useAppHelpers();

const columnDef = ref([
    {
        label: 'consent',
        key: 'consent',
        isSlot: true,
        header_class: 'consent-col'
    },
    {
        label: 'user',
        key: 'username',
        sortKey: 'users.username',
        sortable: true
    },
    {
        label: 'action',
        key: 'consent_type',
        sortable: true,
        isSlot: true
    },
    {
        label: 'context',
        key: 'survey_id',
        sortable: true,
        isSlot: true
    },
    {
        label: 'IP Address',
        key: 'ip_address',
        class: 'text-center'
    },
    {
        key: 'updated_at',
        label: 'time',
        sortable: true,
        formatter: (val, row) => helper.dateTimeFormatter(val)
    },
]);

const expandedRows = ref(new Set());
const isExpanded = (id) => expandedRows.value.has(id);
const toggleExpand = (id) => {
    if (!id) return;
    if (expandedRows.value.has(id)) {
        expandedRows.value.delete(id);
    } else {
        expandedRows.value.add(id);
    }
    // Force reactivity update for Set
    expandedRows.value = new Set(expandedRows.value);
};

const adminTabItems = ref(null);
onMounted(() => {
    helper.loaderOn(adminTabItems.value);
});

</script>

<style scoped>
.consent-col {
  max-width: 480px;
}

.consent-content {
  max-width: 480px;
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.wrap {
	text-wrap-mode: wrap;
}
</style>
